export const levelGeneralListDto = {
    guid: 'guid',
    deleted: 'deleted',
    inactive: 'inactive',
} as const;

export type TLevelGeneralListDto = (typeof levelGeneralListDto)[keyof typeof levelGeneralListDto];
export interface ILevelGeneralListDto
{
    [levelGeneralListDto.guid]: string | null;
    [levelGeneralListDto.deleted]: boolean | null;
    [levelGeneralListDto.inactive]: boolean | null;
}

export class LevelGeneralListDto
    implements ILevelGeneralListDto
{
    [levelGeneralListDto.guid]: string | null = null;
    [levelGeneralListDto.deleted]: boolean | null = null;
    [levelGeneralListDto.inactive]: boolean | null = null;
}
